module.exports = __webpack_public_path__ + "img/powersole.0349a682.jpg";